import React from 'react';
import TabbedPage from '../../components/common/TabbedPage';
import ExpenseList from './ExpenseList';
import ExpenseCategories from '../settings/ExpenseCategories';

// Accounting › Expenses — /accounting/expenses?tab=expenses|categories (categories moved here from Configuration).
const ExpenseTabs = ({ currentUser }) => (
  <TabbedPage tabs={[
    { key: 'expenses', label: 'Expenses', element: <ExpenseList currentUser={currentUser} /> },
    { key: 'categories', label: 'Categories', element: <ExpenseCategories currentUser={currentUser} /> },
  ]} />
);

export default ExpenseTabs;
